import { Breakpoints, Layout, LayoutRowGap } from '@volkswagen-onehub/components-core';
import React from 'react';
import { useSelector } from 'react-redux';
import { OneFormState } from 'src/types';

interface OneElementTemplateProps {
	children: React.ReactNode;
	notALayer?: boolean;
}

export function LayoutWrapper(props: OneElementTemplateProps) {
	const { children } = props;
	const { formInfo } = useSelector((state: OneFormState) => state);

	const inPage = props.notALayer ?? formInfo.notALayer; // Si props.notALayer es undefined asignamos formInfo.notALayer

	return (
		<Layout
			allowOverflowingContent
			appearance={{
				[Breakpoints.default]: [
					{ name: '.', columns: 2 },
					{ name: 'a', columns: 20 },
					{ name: '.', columns: 2 },
				],
				[Breakpoints.b960]: [
					{ name: '.', columns: 3 },
					{ name: 'a', columns: 18 },
					{ name: '.', columns: 3 },
				],
				...(inPage
					? {
							[Breakpoints.b1280]: [
								{ name: '.', columns: 5 },
								{ name: 'a', columns: 14 },
								{ name: '.', columns: 5 },
							],
							[Breakpoints.b1920]: [
								{ name: '.', columns: 6 },
								{ name: 'a', columns: 12 },
								{ name: '.', columns: 6 },
							],
							[Breakpoints.b2560]: [
								{ name: '.', columns: 7 },
								{ name: 'a', columns: 10 },
								{ name: '.', columns: 7 },
							],
					  }
					: {}),
			}}
			rowGap={LayoutRowGap.static300}
		>
			{children}
		</Layout>
	);
}
